<template>
  <budget-detail-team-members-table :tableMode="'team'" v-if="budgetLoaded"></budget-detail-team-members-table>
  <div class="d-flex justify-content-center align-items-center" v-else>
    <spinner />
  </div>
</template>

<script>
import BudgetDetailTeamMembersTable from '../../_components/detail/BudgetDetailTeamMembersTable'
import Spinner from '@/components/Commons/Spinner'
export default {
  name: 'BudgetTeamMembers',
  components: { BudgetDetailTeamMembersTable, Spinner },
  data () {
    return {
      budgetLoaded: false
    }
  },
  computed: {
    budgetId () {
      return this.$route.params.id || 0
    }
  },
  async created () {
    await this.$store.dispatch('BudgetsStore/fetchBudget', this.budgetId)
    this.budgetLoaded = true
    this.$emit('budgetLoaded', this.budgetLoaded)
  }
}
</script>
